<template>
    <div class="content content-fixed content-auth-alt">
        <div class="container d-flex justify-content-center ht-100p">
            <div class="mx-wd-1000 wd-sm-1050 ht-100p d-flex flex-column align-items-center justify-content-center">
                <div class="wd-80p wd-sm-300 mg-b-15"><router-link to="/"><img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/logo.png" class="img-fluid" alt=""></router-link></div>
                <h4 class="tx-20 tx-sm-24">Add New Company</h4> <p align="center" @click="navigate" v-if="company.companies.length > 0" style="font-size: 12px; cursor: pointer">back to dashboard</p>
                <create-company-form style="border-color: transparent;"></create-company-form>
            </div>
        </div><!-- container -->
    </div><!-- content -->
</template>

<script>
    import CreateCompanyForm from "../../components/form/CreateCompanyForm";
    import {mapState} from 'vuex'
    export default {
        name: "Forgot",
        components:{
            CreateCompanyForm
        },
        methods:{
            navigate(){
                window.location = '/dashboard'
            }
        },
        computed:{
            ...mapState([
                'company',
                'system',
            ])
        }
    }
</script>

<style scoped>

</style>